export const tableHeaderVariant = 'title-display-h4-bold';
export const tableDataLabelVariant = 'subheader';
export const tableDataVariant = 'body1';